import { GetDetranDebitPaymentRequest, GetDetranDebitPaymentResponse, GetPlateDebitsResponse } from "services/types";
import { GetAllDebitsRequest } from "./dto/get-debits.dto";
import { api } from "services/api";
import { useMutation } from "react-query";
import { OptionUseMutation } from "config/react-query";
import { id_establishment_default } from "config/establishment";
import reCaptcha from "services/RecaptchaService";

export const useGetDebits = (
  options: OptionUseMutation<GetPlateDebitsResponse> = {}
) => {
  return useMutation("get-debits", getDebits, options);
};

export const useSearchDetranDebitPayment = (
  options: OptionUseMutation<GetDetranDebitPaymentResponse> = {}
) => {
  return useMutation("search-detran-debit-payment", searchDetranDebitPayment, options);
};

async function getDebits({
  id_establishment,
  license_plate,
  renavam,
  document,
  state,
}: GetAllDebitsRequest): Promise<GetPlateDebitsResponse> {
  const token = await reCaptcha.getRecaptchaToken();

  const response = await api.get("/partner/detran/debits", {
    params: {
      ...(!!license_plate && { license_plate }),
      ...(!!renavam && { renavam }),
      ...(!!document && { document }),
      ...(!!state && { state }),
    },
    headers: {
      "id-establishment": id_establishment || id_establishment_default,
      "x-recaptcha-token": token
    },
  });

  return response.data;
}

async function searchDetranDebitPayment({ external_debit_id, id_establishment }: GetDetranDebitPaymentRequest): Promise<GetDetranDebitPaymentResponse> {
  const response = await api.get(`/partner/detran/debits/${external_debit_id}/pay`, {
    headers: {
      "id-establishment": id_establishment || id_establishment_default,
    },
  });

  return response.data;
}